import { InvoiceCorrectionPosition } from "./invoice-correction-position.model"

export class Reversal {
	reason: string
	positionsToBeReversed: InvoiceCorrectionPosition[]
}



// WEBPACK FOOTER //
// ./src/app/models/reversal.model.ts